import { formatDataValue } from 'utils/formatFns';

export const disruptionsFields = {
  disruptionAge: {
    label: 'Age',
    getValue: (disruption) => disruption?.age,
    formatValue: (value) => `${formatDataValue({ value })} Days`,
  },
  disruptionReason: {
    label: 'Disruption Reason',
    getValue: (disruption) => disruption?.reason,
    formatValue: (value) => formatDataValue({ value }),
  },
  disruptionStartDate: {
    label: 'Disruption Start Date',
    getValue: (disruption) => disruption?.eventStartDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  disruptionSubType: {
    label: 'Disruption Sub-Type',
    getValue: (disruption) => disruption?.subType,
    formatValue: (value) => formatDataValue({ value }),
  },
  disruptionType: {
    label: 'Disruption Type',
    getValue: (disruption) => disruption?.type,
    formatValue: (value) => formatDataValue({ value }),
  },
  disruptionCreatedBy: {
    label: 'Created By',
    getValue: (disruption) => disruption?.createdBy,
    formatValue: (value) => formatDataValue({ value }),
  },
  disruptionComments: {
    label: 'Comments',
    getValue: (disruption) => disruption?.comment,
    formatValue: (value) => formatDataValue({ value }),
  },
  disruptionEndDate: {
    label: 'Disruption End Date',
    getValue: (disruption) => disruption?.eventEndDateFmt,
    formatValue: (value) => formatDataValue({ value, fallbackString: 'TBD' }),
  },
  disruptionSubDescription: {
    label: 'Disruption Sub Description',
    getValue: (disruption) => disruption?.subType,
    formatValue: (value) => formatDataValue({ value }),
  },
  disruptionDuration: {
    label: 'Duration',
    getValue: (disruption) => disruption?.age,
    formatValue: (value) => `${formatDataValue({ value })} Days`,
  },
};
